import { apiFetch } from './v2Client';
export interface CompilerProfileCapability {
  id: string; region: string; ectdVersion: '3.2.2' | '4.0'; label: string; scope: string;
  generation: 'legacy' | 'initial' | 'unavailable'; modules: number[]; applicationTypes: string[];
  sequenceScope: 'lifecycle' | 'initial' | 'unavailable';
  validation: { automated: string[]; requiresEvidence: string[] };
  limitations: string[]; officialPackageIds: string[];
}
export const compilerProfilesApi = {
  list: (region?: string, ectdVersion?: string): Promise<{ profiles: CompilerProfileCapability[] }> => {
    const query = new URLSearchParams();
    if (region) query.set('region', region);
    if (ectdVersion) query.set('ectdVersion', ectdVersion);
    return apiFetch(`/api/v1/compiler-profiles${query.size ? `?${query}` : ''}`);
  },
};
